<script lang="ts">
  import { onMount } from "svelte";
  import Header from "../../components/header/Header.svelte";

  let element: HTMLElement;
  let isHeaderActive: boolean = false;
  const headerActiveScrollThreshhold = -30;

  function handlePagePositionChange() {
    isHeaderActive =
      element.getBoundingClientRect().top < headerActiveScrollThreshhold;
  }

  onMount(() => {
    document.body.addEventListener("scroll", handlePagePositionChange);
    return () => {
      document.body.removeEventListener("scroll", handlePagePositionChange);
    }
  });
</script>

<div
  bind:this={element}
  class="page-wrapper"
>
  <Header isActive={isHeaderActive}/>
  <slot />
</div>

<style lang="postcss">
  .page-wrapper::before {
    @apply absolute top-0 left-0 right-0;
    content: "";
    height: 810px;
    z-index: -1;
    background: linear-gradient(
      180deg,
      rgba(59, 199, 255, 0.1) 0%,
      rgba(255, 255, 255, 0) 100%
    );
  }
</style>
